import React from 'react'
import { Doughnut } from 'react-chartjs-2'
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
} from 'chart.js'
import './ModuleStatusChart.scss'

ChartJS.register(ArcElement, Tooltip, Legend)

const ModuleStatusChart = ({ statistics }) => {
  if (!statistics) {
    return (
      <div className="module-status-chart">
        <div className="chart-header">
          <h3 className="chart-title">Module Status Distribution</h3>
          <p className="chart-subtitle">No data available</p>
        </div>
      </div>
    )
  }

  const data = {
    labels: ['Published', 'Draft'],
    datasets: [
      {
        data: [statistics.publishedModules, statistics.draftModules],
        backgroundColor: [
          '#10b981',
          '#f59e0b'
        ],
        borderColor: [
          '#059669',
          '#d97706'
        ],
        borderWidth: 2,
        hoverBackgroundColor: [
          '#34d399',
          '#fbbf24'
        ]
      }
    ]
  }

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom',
        labels: {
          padding: 20,
          usePointStyle: true,
          font: {
            size: 14,
            weight: '600'
          }
        }
      },
      tooltip: {
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        titleColor: '#fff',
        bodyColor: '#fff',
        borderColor: '#e5e7eb',
        borderWidth: 1,
        cornerRadius: 8,
        displayColors: true,
        callbacks: {
          label: function(context) {
            const total = context.dataset.data.reduce((a, b) => a + b, 0)
            const percentage = ((context.parsed / total) * 100).toFixed(1)
            return `${context.label}: ${context.parsed} (${percentage}%)`
          }
        }
      }
    },
    cutout: '60%'
  }

  return (
    <div className="module-status-chart">
      <div className="chart-header">
        <h3 className="chart-title">Module Status Distribution</h3>
        <p className="chart-subtitle">Published vs Draft modules</p>
      </div>
      <div className="chart-container">
        <Doughnut data={data} options={options} />
      </div>
      <div className="chart-summary">
        <div className="summary-item">
          <span className="summary-label">Total Modules:</span>
          <span className="summary-value">{statistics.totalModules}</span>
        </div>
        <div className="summary-item">
          <span className="summary-label">Published Rate:</span>
          <span className="summary-value">
            {statistics.totalModules > 0 ? ((statistics.publishedModules / statistics.totalModules) * 100).toFixed(1) : 0}%
          </span>
        </div>
      </div>
    </div>
  )
}

export default ModuleStatusChart
